/* @flow */
// typecheck: ignore file
import React from 'react';
import cx from 'classnames';
import BoxBody from 'components/BoxBody.jsx';
import DepositConfirmationContainer from 'payments/containers/DepositConfirmationContainer.jsx';
import DepositModalDepositView from 'payments/components/DepositModalDepositView.jsx';
import Dialog from 'components/Dialog.jsx';
import Activity from 'entities/Activity';

import './styles/DepositModal.scss';

type Props = {
  activity: Activity,
  className?: string,
  onRequestHide?: () => void,
}

type State = {
  view: 'deposit' | 'success',
}

class DepositModal extends React.Component {
  props: Props

  state: State = {
    view: 'deposit',
  }

  onDeposited = () => {
    this.setState({ view: 'success' });
  }

  renderContent = () => {
    switch (this.state.view) {
      case 'deposit':
        return (
          <DepositModalDepositView
            activity={this.props.activity}
            onDeposited={this.onDeposited}
          />
        );
      case 'success':
        return (
          <BoxBody>
            <DepositConfirmationContainer
              activityUUID={this.props.activity.id}
              onComplete={this.props.onRequestHide}
            />
          </BoxBody>
        );
      default:
        throw new Error('unknow view in deposit modal');
    }
  }

  render = () => {
    const { className, onRequestHide, ...rest } = this.props;

    return (
      <Dialog
        eventScreenName="DepositModal"
        {...rest}
        size="small"
        onRequestHide={onRequestHide}
        className={cx('DepositModal', className)}>
        {this.renderContent()}
      </Dialog>
    );
  }
}

export default DepositModal;



// WEBPACK FOOTER //
// ./src/payments/components/DepositModal.jsx